import { render, staticRenderFns } from "./XhSelect.vue?vue&type=template&id=2b9a075c&scoped=true"
import script from "./XhSelect.vue?vue&type=script&lang=js"
export * from "./XhSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a075c",
  null
  
)

export default component.exports